import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
} from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { setContext } from '@apollo/client/link/context';
import { ErrorLink, onError } from '@apollo/client/link/error';

import { getApiUrl } from '@/utils';

export const useWebApiClient = () => {
  const httpLink = createHttpLink({
    uri: getApiUrl(),
  });

  const errorLink = onError((options: ErrorLink.ErrorHandlerOptions) => {
    console.log(`[Operation] ${options.operation.operationName}`);
    if (CombinedGraphQLErrors.is(options.error)) {
      options.error.errors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL data error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    } else {
      console.log(`[Network error]: ${options.error}`);
    }
  });

  const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
      },
    };
  });

  const webApiClient = new ApolloClient({
    link: from([authLink, errorLink, httpLink]),
    cache: new InMemoryCache({}),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });

  return {
    webApiClient,
  };
};
